<template>
	<div class="chat-message-item">
		<div class="message-tip" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TEXT">
			{{ msgInfo.content }}
		</div>
		<div class="message-tip" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TIME">
			{{ $date.toTimeText(msgInfo.sendTime) }}
		</div>
		<div class="message-normal" v-else-if="isNormal" :class="{ 'message-mine': mine }">
			<div class="head-image" @contextmenu.prevent="showRobotRightMenu($event)">
														<HeadImage :name="showName" :size="38" :url="headImage" :id="msgInfo.sendId" :group="group" :is-blocked="isRobotBlocked" :is-dnd="isRobotDnd"></HeadImage>
													</div>
			<div class="content">
				<div v-show="mode == 1 && msgInfo.groupId && !msgInfo.selfSend" class="message-top">
				<span>{{ showName }}</span>
				<span v-if="msgInfo.sendId === 0" class="robot-tag">机器人</span>
				<span v-if="isGroupMessage && isGroupOwner" class="owner-tag">群主</span>
			</div>
			<div v-show="mode == 2" class="message-top">
				<span>{{ showName }}</span>
				<span v-if="msgInfo.sendId === 0" class="robot-tag">机器人</span>
				<span v-if="isGroupMessage && isGroupOwner" class="owner-tag">群主</span>
				<span>{{ $date.toTimeText(msgInfo.sendTime) }}</span>
			</div>
				<div class="message-bottom" @contextmenu.prevent="showRightMenu($event)">
					<div ref="chatMsgBox" class="message-content-wrapper">
						<span class="message-text" v-if="isTextMessage" v-html="htmlText"></span>
						<div class="message-image" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.IMAGE"
							@click="showFullImageBox()">
							<img :style="imageStyle" :src="contentData.thumbUrl" loading="lazy" />
						</div>
						<div class="message-file" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.FILE">
							<div class="chat-file-box" v-loading="sending">
								<div class="chat-file-info">
									<el-link class="chat-file-name" :underline="true" target="_blank" type="primary"
										:href="contentData.url" :download="contentData.name">{{ contentData.name
										}}</el-link>
									<div class="chat-file-size">{{ fileSize }}</div>
								</div>
								<div class="chat-file-icon">
									<span type="primary" class="el-icon-document"></span>
								</div>
							</div>
						</div>
						<div class="message-voice" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.AUDIO"
							@click="onPlayVoice()">
							<audio controls :src="JSON.parse(msgInfo.content).url"></audio>
						</div>
						<div title="发送中" v-if="sending" class="sending" v-loading="'true'"></div>
						<div title="发送失败" v-else-if="sendFail" @click="onSendFail" class="send-fail el-icon-warning">
						</div>
					</div>
					<div class="chat-action message-text" v-if="isAction">
						<span v-if="msgInfo.type == $enums.MESSAGE_TYPE.ACT_RT_VOICE" title="重新呼叫"
							@click="$emit('call')" class="iconfont icon-chat-voice"></span>
						<span v-if="msgInfo.type == $enums.MESSAGE_TYPE.ACT_RT_VIDEO" title="重新呼叫"
							@click="$emit('call')" class="iconfont icon-chat-video"></span>
						<span>{{ msgInfo.content }}</span>
					</div>
					<div class="message-status" v-if="!isAction && msgInfo.selfSend && !isGroupMessage">
						<span class="chat-readed" v-if="msgInfo.status == $enums.MESSAGE_STATUS.READED">已读</span>
						<span class="chat-unread" v-else>未读</span>
					</div>
					<div class="chat-receipt" v-show="msgInfo.receipt&&msgInfo.selfSend" @click="onShowReadedBox">
						<span v-if="msgInfo.receiptOk" class="icon iconfont icon-ok" title="全体已读"></span>
						<span v-else>{{ msgInfo.readedCount }}人已读</span>
					</div>
				</div>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
		<chat-group-readed ref="chatGroupReadedBox" :msgInfo="msgInfo" :groupMembers="groupMembers"></chat-group-readed>
	</div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
import RightMenu from '../common/RightMenu.vue';
import ChatGroupReaded from './ChatGroupReaded.vue';
export default {
	name: "messageItem",
	components: {
		HeadImage,
		RightMenu,
		ChatGroupReaded
	},
	props: {
		mode: {
			type: Number,
			default: 1
		},
		mine: {
			type: Boolean,
			required: true
		},
		headImage: {
			type: String,
			required: true
		},
		showName: {
			type: String,
			required: true
		},
		msgInfo: {
			type: Object,
			required: true
		},
		groupMembers: {
			type: Array
		},
		group: {
			type: Object,
			default: null
		},
		menu: {
			type: Boolean,
			default: true
		},
		searchKeyword: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			audioPlayState: 'STOP'
		}
	},
	methods: {
		onSendFail() {
			this.$emit("resend", this.msgInfo);
		},
		showFullImageBox() {
			let imageUrl = JSON.parse(this.msgInfo.content).originUrl;
			if (imageUrl) {
				this.$eventBus.$emit("openFullImage", imageUrl);
			}
		},
		onPlayVoice() {
			if (!this.audio) {
				this.audio = new Audio();
			}
			this.audio.src = JSON.parse(this.msgInfo.content).url;
			this.audio.play();
			this.onPlayVoice = 'RUNNING';
		},
		showRightMenu(e) {
			this.$refs.rightMenu.open(e, this.menuItems);
		},
		onSelectMenu(item) {
			// 处理机器人免打扰设置
			if (item.key === 'ROBOT_ENABLE' || item.key === 'ROBOT_DISABLE') {
				const isDnd = item.key === 'ROBOT_DISABLE';
				this.$http({
					url: '/group/robot/dnd/set',
					method: 'post',
					data: {
						groupId: this.msgInfo.groupId,
						robotId: this.msgInfo.robotId,
						isDnd: isDnd
					}
				}).then(() => {
					// 更新本地状态
					if (!this.groupStore.robotDndSettings) {
						this.groupStore.robotDndSettings = {};
					}
					if (!this.groupStore.robotDndSettings[this.msgInfo.groupId]) {
						this.groupStore.robotDndSettings[this.msgInfo.groupId] = {};
					}
					if (!this.groupStore.robotDndSettings[this.msgInfo.groupId][this.msgInfo.robotId]) {
						this.groupStore.robotDndSettings[this.msgInfo.groupId][this.msgInfo.robotId] = {};
					}
					this.groupStore.robotDndSettings[this.msgInfo.groupId][this.msgInfo.robotId].isDnd = isDnd;
					this.$message.success(isDnd ? '已开启消息免打扰' : '已关闭消息免打扰');
				}).catch(() => {
					this.$message.error('设置失败，请重试');
				});
			} else if (item.key === 'ROBOT_BLOCK' || item.key === 'ROBOT_UNBLOCK') {
				const isBlocked = item.key === 'ROBOT_BLOCK';
				this.$http({
					url: '/group/robot/dnd/set',
					method: 'post',
					data: {
						groupId: this.msgInfo.groupId,
						robotId: this.msgInfo.robotId,
						isBlocked: isBlocked
					}
				}).then(() => {
					// 更新本地状态
					if (!this.groupStore.robotDndSettings) {
						this.groupStore.robotDndSettings = {};
					}
					if (!this.groupStore.robotDndSettings[this.msgInfo.groupId]) {
						this.groupStore.robotDndSettings[this.msgInfo.groupId] = {};
					}
					if (!this.groupStore.robotDndSettings[this.msgInfo.groupId][this.msgInfo.robotId]) {
						this.groupStore.robotDndSettings[this.msgInfo.groupId][this.msgInfo.robotId] = {};
					}
					this.groupStore.robotDndSettings[this.msgInfo.groupId][this.msgInfo.robotId].isBlocked = isBlocked;
					this.$message.success(isBlocked ? '已屏蔽机器人发言' : '已解除屏蔽机器人发言');
				}).catch(() => {
					this.$message.error('设置失败，请重试');
				});
			} else {
				this.$emit(item.key.toLowerCase(), this.msgInfo);
			}
		},
		onShowReadedBox() {
			let rect = this.$refs.chatMsgBox.getBoundingClientRect();
			this.$refs.chatGroupReadedBox.open(rect);
		},
		showRobotRightMenu(e) {
			// 只对机器人消息显示右键菜单
			if (this.msgInfo.sendId === 0 && this.msgInfo.groupId) {
				this.$refs.rightMenu.open(e, this.robotMenuItems);
			}
		}
	},
	computed: {
		sending() {
			return this.msgInfo.status == this.$enums.MESSAGE_STATUS.SENDING;
		},
		sendFail() {
			return this.msgInfo.status == this.$enums.MESSAGE_STATUS.FAILED;
		},
		contentData() {
			return JSON.parse(this.msgInfo.content)
		},
		fileSize() {
			let size = this.contentData.size;
			if (size > 1024 * 1024) {
				return Math.round(size / 1024 / 1024) + "M";
			}
			if (size > 1024) {
				return Math.round(size / 1024) + "KB";
			}
			return size + "B";
		},
		menuItems() {
			let items = [];
			items.push({
				key: 'DELETE',
				name: '删除',
				icon: 'el-icon-delete'
			});
			// 检查是否可以撤回消息：
			// 1. 自己发送的消息
			// 2. 群主可以撤回群里所有人的消息（包括自己、机器人、群成员）
			let canRecall = false;
			if (this.msgInfo.selfSend && this.msgInfo.id > 0) {
				canRecall = true;
			} else if (this.msgInfo.groupId && this.group && this.group.ownerId && this.group.ownerId === this.userStore.userInfo?.id) {
				// 群主可以撤回群里任何人的消息
				canRecall = true;
			}
			if (canRecall) {
				items.push({
					key: 'RECALL',
					name: '撤回',
					icon: 'el-icon-refresh-left'
				});
			}
			return items;
		},
		isTextMessage() {
			return this.msgInfo.type == this.$enums.MESSAGE_TYPE.TEXT
		},
		isAction() {
			return this.$msgType.isAction(this.msgInfo.type);
		},
		isNormal() {
			const type = this.msgInfo.type;
			return this.$msgType.isNormal(type) || this.$msgType.isAction(type)
		},
		htmlText() {
			let color = this.msgInfo.selfSend ? 'white' : '';
			let text = this.msgInfo.content;
			// 格式化消息内容，移除所有多余的空白换行
			text = text.replace(/\n\s*/g, '\n');
			// 1. 先解析Markdown图片链接
			// 支持格式：![alt](url) 和 ![](url)
			text = text.replace(/!\[([^\]]*)\]\(([^\)]+)\)/g, function(match, alt, url) {
				// 移除URL中的所有空白字符和反引号
				let imgUrl = url.replace(/[`\s]+/g, '');
				// 验证是否是有效的URL
				if (!imgUrl || !/^https?:\/\//.test(imgUrl)) {
					return match; // 如果不是有效URL，返回原始文本
				}
				// 生成唯一标记，避免被后续操作修改
				let uniqueId = 'img_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
				window.__imgMarkers = window.__imgMarkers || {};
				window.__imgMarkers[uniqueId] = `<img src="${imgUrl}" alt="${alt || ''}" style="max-width: 100%; max-height: 300px; border-radius: 8px; margin: 5px 0; cursor: pointer;" onclick="showFullImage('${imgUrl}')" />`;
				return uniqueId;
			});
			// 3. 解析标准Markdown链接
			// 支持格式：[link text](url)
			text = text.replace(/\[([^\]]*)\]\(([^\)]+)\)/g, function(match, linkText, url) {
				// 移除URL中的所有空白字符和反引号
				let linkUrl = url.replace(/[`\s]+/g, '');
				// 验证是否是有效的URL
				if (!linkUrl || !/^https?:\/\//.test(linkUrl)) {
					return match; // 如果不是有效URL，返回原始文本
				}
				// 生成唯一标记，避免被后续操作修改
				let uniqueId = 'link_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
				window.__linkMarkers = window.__linkMarkers || {};
				window.__linkMarkers[uniqueId] = `<a href="${linkUrl}" target="_blank" style="color: #1890ff; text-decoration: none;" rel="noopener noreferrer">${linkText}</a>`;
				return uniqueId;
			});
			// 4. 处理连续3个或以上的"-",转换为分隔线，并去除前后的空白行
			text = text.replace(/\s*[-]{3,}\s*/g, function(match) {
				// 生成唯一标记，避免被后续操作修改
				let uniqueId = 'hr_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
				window.__hrMarkers = window.__hrMarkers || {};
				window.__hrMarkers[uniqueId] = '<hr style="border: none; border-top: 1px solid #e6e6e6; margin: 5px 0;" />';
				return uniqueId;
			});
			// 5. 处理Markdown引用消息（以">"开头的行）
			// 匹配连续的引用行，避免每一行都生成一个独立的引用块
			text = text.replace(/^(>.*(?:\n>.*)*)$/gm, function(match) {
				// 生成唯一标记，避免被后续操作修改
				let uniqueId = 'quote_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
				window.__quoteMarkers = window.__quoteMarkers || {};
				// 将连续的引用行合并为一个引用块
				let content = match.replace(/^>/gm, '').trim();
				window.__quoteMarkers[uniqueId] = '<blockquote style="border-left: 4px solid #e6e6e6; padding-left: 10px; margin: 5px 0; color: #666; font-style: italic;">' + content + '</blockquote>';
				return uniqueId;
			});
			// 3. 对非HTML部分进行转义
			text = this.$str.html2Escape(text);
			// 4. 替换URL为HTML链接
			text = this.$url.replaceURLWithHTMLLinks(text, color);
			// 5. 转换emoji
			text = this.$emo.transform(text, 'emoji-normal');
			// 6. 高亮搜索关键字
			if (this.searchKeyword) {
				const keyword = this.searchKeyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // 转义正则特殊字符
				const regex = new RegExp(`(${keyword})`, 'gi');
				text = text.replace(regex, '<span style="background-color: #ffeb3b; color: #000;">$1</span>');
			}
			// 7. 恢复图片标签
			if (window.__imgMarkers) {
				for (let id in window.__imgMarkers) {
					text = text.replace(new RegExp(id, 'g'), window.__imgMarkers[id]);
				}
				// 清理标记
				window.__imgMarkers = {};
			}
			// 8. 恢复链接标签
			if (window.__linkMarkers) {
				for (let id in window.__linkMarkers) {
					text = text.replace(new RegExp(id, 'g'), window.__linkMarkers[id]);
				}
				// 清理标记
				window.__linkMarkers = {};
			}
			// 9. 恢复分隔线标签
			if (window.__hrMarkers) {
				for (let id in window.__hrMarkers) {
					text = text.replace(new RegExp(id, 'g'), window.__hrMarkers[id]);
				}
				// 清理标记
				window.__hrMarkers = {};
			}
			// 10. 恢复引用消息标签
			if (window.__quoteMarkers) {
				for (let id in window.__quoteMarkers) {
					text = text.replace(new RegExp(id, 'g'), window.__quoteMarkers[id]);
				}
				// 清理标记
				window.__quoteMarkers = {};
			}
			return text;
		},
		isGroupMessage() {
			return !!this.msgInfo.groupId;
		},
		isGroupOwner() {
			return this.isGroupMessage && this.group && this.group.ownerId && this.msgInfo.sendId === this.group.ownerId;
		},
		robotMenuItems() {
			let items = [];
			// 检查是否已设置免打扰
			const isDnd = this.groupStore.robotDndSettings?.[this.msgInfo.groupId]?.[this.msgInfo.robotId]?.isDnd || false;
			// 检查是否已屏蔽发言
			const isBlocked = this.groupStore.robotDndSettings?.[this.msgInfo.groupId]?.[this.msgInfo.robotId]?.isBlocked || false;
			items.push({
				key: isDnd ? 'ROBOT_ENABLE' : 'ROBOT_DISABLE',
				name: isDnd ? '新消息提醒' : '消息免打扰',
				icon: isDnd ? 'el-icon-bell' : 'el-icon-bell-on'
			});
			items.push({
				key: isBlocked ? 'ROBOT_UNBLOCK' : 'ROBOT_BLOCK',
				name: isBlocked ? '解除屏蔽发言' : '屏蔽发言',
				icon: isBlocked ? 'el-icon-check' : 'el-icon-close'
			});
			return items;
		},
		isRobotBlocked() {
			// 检查机器人是否被屏蔽
			return this.groupStore.robotDndSettings?.[this.msgInfo.groupId]?.[this.msgInfo.robotId]?.isBlocked || false;
		},
		isRobotDnd() {
			// 检查机器人是否被设置为免打扰
			return this.groupStore.robotDndSettings?.[this.msgInfo.groupId]?.[this.msgInfo.robotId]?.isDnd || false;
		},
		imageStyle() {
			// 计算图片的显示宽高，要求：任意边不能高于360px,不能低于60px,不能拉伸图片比例
			let maxSize = this.configStore.fullScreen ? 360 : 240;
			let minSize = 60;
			let width = this.contentData.width;
			let height = this.contentData.height;
			if (width && height) {
				let ratio = Math.min(width, height) / Math.max(width, height);
				let w = Math.max(Math.min(width > height ? maxSize : ratio * maxSize, width), minSize);
				let h = Math.max(Math.min(width > height ? ratio * maxSize : maxSize, height), minSize);
				return `width: ${w}px;height:${h}px;object-fit: cover;`
			} else {
				// 兼容历史版本，历史数据没有记录宽高
				return `max-width: ${maxSize}px;min-width:60px;max-height: ${maxSize}px;min-height:60px;`
			}
		}
	}
}
</script>

<style lang="scss">
.chat-message-item {
	padding: 3px 10px;
	border-radius: 10px;

	.message-tip {
		line-height: 50px;
		font-size: var(--im-font-size-small);
		color: var(--im-text-color-light);
	}

	.message-normal {
		position: relative;
		font-size: 0;
		padding-left: 48px;
		min-height: 50px;
		margin-top: 10px;

		.head-image {
			position: absolute;
			width: 40px;
			height: 40px;
			top: 0;
			left: 0;
		}

		.content {
			text-align: left;

			.message-top {
				display: flex;
				flex-wrap: nowrap;
				align-items: center;
				color: var(--im-text-color-light);
				font-size: var(--im-font-size);
				line-height: 20px;

				span {
					margin-right: 8px;
				}

				.robot-tag {
					display: inline-block;
					padding: 1px 6px;
					font-size: 10px;
					color: #409EFF;
					background-color: #ECF5FF;
					border-radius: 10px;
					border: 1px solid #D9ECFF;
					margin-right: 8px;
				}
				.owner-tag {
					display: inline-block;
					padding: 1px 6px;
					font-size: 10px;
					color: #FF4D4F;
					background-color: #FFF1F0;
					border-radius: 10px;
					border: 1px solid #FFCCC7;
					margin-right: 8px;
				}
			}

			.message-bottom {
					display: inline-block;
					padding-right: 20px;
					padding-left: 5px;


					.message-content-wrapper {
						position: relative;
						display: flex;
						align-items: flex-end;

						.sending {
							width: 25px;
							height: 25px;

							.circular {
								width: 25px;
								height: 25px;
							}
						}

						.send-fail {
							color: #e45050;
							font-size: 30px;
							cursor: pointer;
							margin: 0 5px;
						}
					}

					.message-text {
						flex: 1;
						display: inline-block;
						position: relative;
						line-height: 26px;
						padding: 6px 10px;
						background-color: var(--im-background);
						border-radius: 10px;
						font-size: var(--im-font-size);
						text-align: left;
						white-space: pre-wrap;
						word-break: break-word;
						max-width: 85%;
						min-width: 80px;
					}

				.message-image {
					border-radius: 8px;
					border: 2px solid var(--im-color-primary-light-9);
					overflow: hidden;
					cursor: pointer;
					background: var(--im-background);
				}

				.message-file {
						display: flex;
						flex-wrap: nowrap;
						flex-direction: row;
						align-items: center;
						cursor: pointer;
						margin-bottom: 2px;
						background: var(--im-background);

						.chat-file-box {
							display: flex;
							flex-wrap: nowrap;
							align-items: center;
							min-height: 60px;
							box-shadow: var(--im-box-shadow-light);
							border-radius: 4px;
							padding: 10px 15px;

							.chat-file-info {
								flex: 1;
								height: 100%;
								text-align: left;
								font-size: 14px;
								margin-right: 10px;

								.chat-file-name {
									display: inline-block;
									min-width: 160px;
									max-width: 220px;
									font-size: 14px;
									margin-bottom: 4px;
									white-space: pre-wrap;
									word-break: break-all;
								}

								.chat-file-size {
									font-size: var(--im-font-size-smaller);
									color: var(--im-text-color-light);
								}
							}

							.chat-file-icon {
								font-size: 44px;
								color: #d42e07;
							}
						}

						.send-fail {
							color: #e60c0c;
							font-size: 30px;
							cursor: pointer;
							margin: 0 20px;
						}

					}

					.message-voice {
						font-size: 14px;
						cursor: pointer;

						audio {
							height: 45px;
							padding: 5px 0;
						}
					}

					.chat-action {
						display: flex;
						align-items: center;

						.iconfont {
							cursor: pointer;
							font-size: 22px;
							padding-right: 8px;
						}
					}

					.message-status {
						margin-top: 3px;
						display: block;

						.chat-readed {
							font-size: 12px;
							color: var(--im-text-color-light);
						}

						.chat-unread {
							font-size: var(--im-font-size-smaller);
							color: var(--im-color-danger);
						}
					}

					.chat-receipt {
						font-size: var(--im-font-size-smaller);
						cursor: pointer;
						color: var(--im-text-color-light);

						.icon-ok {
							font-size: 20px;
							color: var(--im-color-sucess);
						}
					}

					.chat-at-user {
						padding: 2px 5px;
						border-radius: 3px;
						cursor: pointer;
					}
				}
			}


			&.message-mine {
				text-align: right;
				padding-left: 0;
				padding-right: 48px;

				.head-image {
					left: auto;
					right: 0;
				}

				.content {
					text-align: right;

					.message-top {
						flex-direction: row-reverse;

						span {
							margin-left: 12px;
							margin-right: 0;
						}
					}

					.message-bottom {
						padding-left: 20px;
						padding-right: 5px;

						.message-content-wrapper {
							flex-direction: row-reverse;
						}

						.message-text {
							background-color: #07C160;
							color: #fff;
							max-width: 85%;
						}

						.message-image {
							background: #07C160;
							border-color: #07C160;
						}

						.message-file {
							background: #07C160;

							.chat-file-box {
								background: #fff;
							}
						}

						.chat-action {
							flex-direction: row-reverse;

							.iconfont {
								transform: rotateY(180deg);
							}
						}
					}
				}
			}

	}
}
</style>